import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsOpen = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <path
        fill="currentColor"
        d="M22.2888012,11.6712484c-0.3988838,0-0.6991444,0.3002596-0.6991444,0.6991444v6.0424395
		c0,1.7467613-1.4202023,3.1669655-3.1669655,3.1669655H5.5992212c-1.7467628,0-3.1669657-1.4202042-3.1669657-3.1669655v-12.84758
		c0-1.7467625,1.420203-3.1669655,3.1669657-3.1669655h5.9723053c0.3988848,0,0.6991434-0.3002594,0.6991434-0.6991439
		C12.2706699,1.306834,11.9638367,1,11.5715275,1H5.6014137C5.5860715,1,5.5729222,1,5.55758,1
		C4.3609281,1,3.2322171,1.4668258,2.3708904,2.3193867C1.4942217,3.187288,1.012054,4.340107,1.012054,5.5652518v12.84758
		C1.012054,20.9420204,3.0700328,23,5.5992227,23h12.8015537c2.5291901,0,4.5871696-2.0579796,4.5871696-4.5871677v-6.0424395
		c0-0.1994419-0.0745182-0.3813515-0.20821-0.5106592C22.6526184,11.7391911,22.4772854,11.6712484,22.2888012,11.6712484z"
      />
      <path
        fill="currentColor"
        d="M22.2888031,1.0241092l-0.0000019-0.0000014h-5.9481964c-0.3988848,0-0.6991434,0.300258-0.6991434,0.6991425
		c0,0.3923098,0.3068333,0.6991438,0.6991434,0.6991438h4.2518425l-9.4395294,9.4395304
		c-0.1336918,0.1336918-0.2125921,0.3112173-0.2125921,0.4865513s0.0767078,0.3528585,0.2125921,0.4865513
		c0.1271162,0.1271172,0.322176,0.2125931,0.4865513,0.2125931s0.3594351-0.0854759,0.4865513-0.2125931l9.4636383-9.4198046
		v4.2562265c0,0.3988843,0.3002586,0.699142,0.6991444,0.699142c0.3988838,0,0.6991425-0.3002586,0.6991425-0.699142V1.7232517
		C22.9879456,1.3243685,22.6876869,1.0241092,22.2888031,1.0241092z"
      />
    </SvgIcon>
  );
});

export default AppIconsOpen;
